// Optional team table columns in display order; the team member column is always shown.
export const TEAM_COLUMNS = [
  "capturedTime",
  "processTime",
  "sessions",
  "processes",
  "daily",
  "coverage",
  "lastCapture",
] as const;
export type TeamColumn = (typeof TEAM_COLUMNS)[number];
export const DEFAULT_TEAM_COLUMNS: readonly TeamColumn[] = [
  "capturedTime",
  "sessions",
  "processes",
  "daily",
  "coverage",
];
const TEAM_COLUMNS_STORAGE_KEY = "clank.team_activity.columns";

export const readTeamColumns = (): readonly TeamColumn[] => {
  try {
    const parsed: unknown = JSON.parse(
      window.localStorage.getItem(TEAM_COLUMNS_STORAGE_KEY) ?? "null",
    );
    return Array.isArray(parsed)
      ? TEAM_COLUMNS.filter(column => parsed.includes(column))
      : DEFAULT_TEAM_COLUMNS;
  } catch {
    return DEFAULT_TEAM_COLUMNS;
  }
};

export const persistTeamColumns = (columns: readonly TeamColumn[]) => {
  try {
    window.localStorage.setItem(TEAM_COLUMNS_STORAGE_KEY, JSON.stringify(columns));
  } catch {}
};
